<template>
    <section class="relative min-h-screen overflow-hidden bg-[#070707] text-white">
        <picture>
            <source
                media="(max-width: 767px)"
                srcset="@img/home/hero-mobile.webp"
            >

            <img
                src="@img/home/hero.webp"
                alt="Batumi Center House"
                class="absolute inset-0 h-full w-full object-cover object-center md:object-right"
            >
        </picture>

        <div class="absolute inset-0 bg-black/55 md:hidden"></div>

        <div class="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/80 md:hidden"></div>

        <div class="absolute inset-0 hidden bg-gradient-to-b from-black/30 via-transparent to-black/70 md:block"></div>

        <div class="absolute inset-y-0 left-0 hidden w-[58%] bg-gradient-to-r from-black via-black/85 to-transparent md:block"></div>

        <div class="relative z-10 mx-auto flex min-h-screen max-w-7xl flex-col px-5 py-7 lg:px-12">
            <header class="flex items-center justify-between">
                <div class="flex items-center justify-center gap-3">
                    <IconLogo class="h-11 w-11 md:h-16 md:w-16"/>

                    <div class="font-serif text-lg uppercase leading-none tracking-wide">
                        Batumi<br>
                        Center House
                    </div>
                </div>

                <div class="flex items-center gap-4 text-sm uppercase">
                    <Link
                        :href="route('home', {locale: item})"
                        v-for="item in locales"
                        :key="item"
                        type="button"
                        class="pb-1 transition hover:text-white"
                        :class="locale === item ? 'border-b border-white text-white' : 'text-white/60'"
                    >
                        {{ item }}
                    </Link>
                </div>
            </header>

            <div class="flex flex-1 items-center py-14">
                <div class="w-full max-w-3xl">
                    <div class="mb-6 text-sm uppercase tracking-[0.35em] text-[#c8b79c]">
                        {{ t.hero.sale }}
                    </div>

                    <h1 class="font-serif text-4xl uppercase leading-none md:text-7xl lg:text-8xl">
                        {{ t.hero.title }}
                    </h1>

                    <div class="mt-3 font-serif text-2xl uppercase leading-tight md:text-5xl">
                        {{ t.hero.subtitle }}
                    </div>

                    <div class="mt-8 flex items-center gap-3 text-sm text-white/90 md:text-base">
                        <IconMapPoint class="w-7 h-7"/>
                        <span>{{ t.hero.address }}</span>
                    </div>

                    <div class="mt-8 max-w-2xl rounded-2xl border border-white/10 bg-black/20 backdrop-blur-sm">
                        <div class="grid grid-cols-1 md:grid-cols-3">
                            <div
                                v-for="(item, index) in stats"
                                :key="item.label"
                                class="relative px-5 py-5"
                                :class="[
                                    index < stats.length - 1
                                        ? 'border-b border-white/10 md:border-b-0 md:border-r md:border-white/10'
                                        : ''
                                ]"
                            >
                                <div class="font-serif text-3xl leading-none md:text-4xl">
                                    {{ item.value }}
                                </div>

                                <div class="mt-3 text-xs uppercase tracking-wide text-white/60 md:text-sm">
                                    {{ item.label }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-6 grid max-w-2xl grid-cols-1 gap-3 md:grid-cols-2">
                        <a
                            :href="homeStore.whatsappLink"
                            target="_blank"
                            rel="noopener"
                            class="flex h-14 items-center justify-center rounded-xl border border-white/20 bg-black/20 px-6 text-sm uppercase tracking-wide backdrop-blur-sm transition hover:bg-white hover:text-black md:h-16"
                        >
                            WhatsApp
                        </a>

                        <a
                            :href="homeStore.telegramLink"
                            target="_blank"
                            rel="noopener"
                            class="flex h-14 items-center justify-center rounded-xl border border-white/20 bg-black/20 px-6 text-sm uppercase tracking-wide backdrop-blur-sm transition hover:bg-white hover:text-black md:h-16"
                        >
                            Telegram
                        </a>
                    </div>

                    <div class="mt-7 flex flex-wrap items-center gap-4 text-sm text-white/65">
                        <span>
                            {{ t.hero.morePhotos }}
                        </span>

                        <span class="hidden h-px w-8 bg-white/20 md:block"></span>

                        <a
                            :href="`tel:+${homeStore.whatsappPhone}`"
                            class="font-serif text-2xl text-white"
                        >
                            +995 595 15 64 24
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { useHomeStore } from '@js/store/homeStore.js';
import IconLogo from '@js/components/Icons/IconLogo.vue';
import { Link } from '@inertiajs/vue3';
import IconMapPoint from "@js/components/Icons/IconMapPoint.vue";

export default {
    name: 'HeroSection',

    components: {
        IconMapPoint,
        Link,
        IconLogo,
    },

    computed: {
        homeStore() {
            return useHomeStore();
        },

        locale() {
            return this.homeStore.getLocale(this.$page);
        },

        locales() {
            return this.homeStore.getLocales(this.$page);
        },

        t() {
            return this.homeStore.getTranslations(this.locale);
        },

        stats() {
            return this.homeStore.getStats(this.t);
        },
    },
};
</script>
